document.documentElement.classList.remove('no-js');

// Mobile menu toggle
document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-mobile-toggle]');
  if (!toggle) return;
  const panel = document.querySelector('[data-mobile-panel]');
  if (!panel) return;
  panel.toggleAttribute('open');
  toggle.setAttribute('aria-expanded', panel.hasAttribute('open') ? 'true' : 'false');
});

// Announcement bar dismiss
document.addEventListener('click', (event) => {
  const btn = event.target.closest('[data-dismiss-bar]');
  if (!btn) return;
  const bar = btn.closest('.announcement-bar');
  if (bar) {
    bar.style.display = 'none';
    try { sessionStorage.setItem('announcement-dismissed-' + btn.dataset.dismissBar, '1'); } catch (e) {}
  }
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-dismiss-bar]').forEach((btn) => {
    try {
      if (sessionStorage.getItem('announcement-dismissed-' + btn.dataset.dismissBar)) {
        const bar = btn.closest('.announcement-bar');
        if (bar) bar.style.display = 'none';
      }
    } catch (e) {}
  });
});

// Customer login: password recovery toggle
document.addEventListener('click', (event) => {
  if (event.target.matches('a[href="#recover"]')) {
    event.preventDefault();
    const recover = document.getElementById('recover');
    if (recover) recover.style.display = 'block';
  }
  if (event.target.matches('[data-hide-recover]')) {
    event.preventDefault();
    const recover = document.getElementById('recover');
    if (recover) recover.style.display = 'none';
  }
});

// Show recovery form if URL hash is #recover
if (window.location.hash === '#recover') {
  const recover = document.getElementById('recover');
  if (recover) recover.style.display = 'block';
}

// Image lightbox
(function () {
  let overlay = null;

  function getOverlay() {
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'lightbox-overlay';
    overlay.innerHTML = '<button class="lightbox-close" aria-label="Close">&times;</button><img src="" alt="">';
    document.body.appendChild(overlay);
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.hasAttribute('open')) close();
    });
    return overlay;
  }

  function close() {
    if (overlay) overlay.removeAttribute('open');
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-lightbox-trigger]');
    if (!trigger) return;
    e.preventDefault();
    var el = getOverlay();
    var img = el.querySelector('img');
    img.src = trigger.dataset.fullSrc;
    img.alt = (trigger.querySelector('img') || {}).alt || '';
    el.setAttribute('open', '');
  });
})();

// Announcement bar rotation
(function () {
  var bars = document.querySelectorAll('[data-announcement-rotate]');
  bars.forEach(function (bar) {
    var messages = bar.querySelectorAll('[data-announcement-message]');
    if (messages.length < 2) return;
    var speed = parseInt(bar.dataset.announcementRotate, 10) || 4000;
    var current = 0;
    messages[0].classList.add('announcement-msg--active');

    setInterval(function () {
      messages[current].classList.remove('announcement-msg--active');
      current = (current + 1) % messages.length;
      messages[current].classList.add('announcement-msg--active');
    }, speed);
  });
})();

// Gallery tag filter
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-filter-tag]');
    if (!btn) return;
    var container = btn.closest('[data-gallery-filterable]');
    if (!container) return;
    var tag = btn.dataset.filterTag;
    var items = container.querySelectorAll('[data-tags]');
    var buttons = container.querySelectorAll('[data-filter-tag]');

    buttons.forEach(function (b) { b.classList.remove('gallery-filter-btn--active'); });
    btn.classList.add('gallery-filter-btn--active');

    items.forEach(function (item) {
      if (tag === 'all') {
        item.style.display = '';
      } else {
        var tags = item.dataset.tags.split(',');
        item.style.display = tags.indexOf(tag) >= 0 ? '' : 'none';
      }
    });
  });
})();
